import { Form, Button, InputGroup } from "react-bootstrap";
import Swal from "sweetalert2";
import { pushDataLayer } from "../gtm";

export default function Step3({ formData, setFormData, next, prev }) {
  const handleNext = (e) => {
    e.preventDefault();

    const mensajes = [];

    // 1) Validar teléfono (no vacío + solo dígitos)
    const telefono = formData.telefono?.trim() || "";
    if (!telefono) {
      mensajes.push("El teléfono es obligatorio.");
    } else if (!/^\d+$/.test(telefono)) {
      mensajes.push("El teléfono debe contener solo números.");
    }

    // 2) Validar email (no vacío + formato básico)
    const email = formData.email?.trim() || "";
    if (!email) {
      mensajes.push("El correo es obligatorio.");
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        mensajes.push("El formato de email no es válido.");
      }
    }

    if (mensajes.length > 0) {
      // Mostrar SweetAlert con todos los errores
      Swal.fire({
        icon: "error",
        title: "Errores en el formulario",
        html: mensajes.join("<br/>"),
        confirmButtonText: "Entendido",
        confirmButtonColor: "#d33",
      });
      return;
    }

    // Si pasa todas las validaciones, dispara evento y avanza
    pushDataLayer('paso4_cedula_dapartamento');
    next();
  };

  return (
    <div className="form-container">
      <h2 className="form-title">Número de teléfono para contactarte y mail</h2>
      <Form onSubmit={handleNext}>
        <Form.Group className="mb-4">
          <Form.Label>
            Teléfono <span style={{ color: "#000000" }}>*</span>
          </Form.Label>
          <InputGroup>
            <InputGroup.Text>+598</InputGroup.Text>
            <Form.Control
              type="tel"
              placeholder="099123456"
              value={formData.telefono}
              onChange={(e) => {
                const soloNumeros = e.target.value.replace(/\D/g, '');
                setFormData({ ...formData, telefono: soloNumeros });
              }}
            />
          </InputGroup>
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>
            Otro telefono <span style={{ color: "#000000" }}>(opcional)</span>
          </Form.Label>
          <InputGroup>
            <InputGroup.Text>+598</InputGroup.Text>
            <Form.Control
              type="tel"
              placeholder="099123456"
              value={formData.otroTelefono}
              onChange={(e) => {
                const soloNumeros = e.target.value.replace(/\D/g, '');
                setFormData({ ...formData, otroTelefono: soloNumeros });
              }}
            />
          </InputGroup>
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>
            Email <span style={{ color: "#000000" }}>*</span>
          </Form.Label>
          <Form.Control
            type="email"
            placeholder="ejemplo@correo.com"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
          />
        </Form.Group>

        <div className="d-flex justify-content-between">
          <Button variant="secondary" onClick={prev}>
            Atrás
          </Button>
          <Button variant="primary" type="submit">
            Aceptar
          </Button>
        </div>
      </Form>
    </div>
  );
}
